const formatRatingDistribution = distribution =>
  distribution.reduce(
    (acc, curr) => ({
      ...acc,
      [`rating${curr['ratingValue']}`]: {
        count: curr['count'],
      },
    }),
    {
      rating1: {
        count: 0,
      },
      rating2: {
        count: 0,
      },
      rating3: {
        count: 0,
      },
      rating4: {
        count: 0,
      },
      rating5: {
        count: 0,
      },
    }
  );

export default formatRatingDistribution;
export { formatRatingDistribution };
